import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { initialSettings } from "../../../core/common/selectoption/selectoption";
import Select from "react-select";
import DatePicker from "react-datepicker";
import {
  ClientPlanDetails,
  createClient,
  deleteClient,
  fetchClientPlan,
  fetchClients,
  fetchCustomClientInfo,
  fetchPlans,
  updateClient,
  updateClientPlan,
} from "../../../api/client";
import { toast } from "react-toastify";
import { highlightMatch } from "../../../core/common/highlightmatch";

type PasswordField = "password" | "confirmPassword";
interface FormattedClient {
  key: number;
  client_id: string; // ✅ ADD this
  CompanyName: string;
  Email: string;
  AccountURL: string;
  Plan: string;
  CreatedDate: string;
  Status: string;
  Image: string;
}

const Company = () => {
  const route = all_routes;
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [data, setData] = useState<FormattedClient[]>([]);
  const [plans, setPlans] = useState<{ label: string; value: string }[]>([]);
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);
  const [clientIdToDelete, setClientIdToDelete] = useState<string | null>(null);
  const [clientPlan, setClientPlan] = useState<ClientPlanDetails | null>(null);
  const [newPlanId, setNewPlanId] = useState<string>("");
  const [newPlanName, setNewPlanName] = useState<string>("");
  const [newPlanType, setNewPlanType] = useState<string>("");
  const [newPlanPrice, setNewPlanPrice] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paymentDate, setPaymentDate] = useState<Date | null>(null);
  const [expireDate, setExpireDate] = useState<Date | null>(null);
  const [clients, setClients] = useState<FormattedClient[]>([]);
  const [filteredClients, setFilteredClients] = useState<FormattedClient[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("recently_added");
  const [visibleColumns, setVisibleColumns] = useState<string[]>([
    "Name",
    "Email",
    "Account URL",
    "Website",
    "Plan",
    "Created Date",
    "Status",
    "created_date",
    "Action",
  ]);
  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: initialSettings.startDate,
    endDate: initialSettings.endDate,
  });
  const [showAddClient, setShowAddClient] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const handleToggleColumn = (columnName: string) => {
    setVisibleColumns((prev) =>
      prev.includes(columnName)
        ? prev.filter((col) => col !== columnName)
        : [...prev, columnName]
    );
  };

  const [formValues, setFormValues] = useState({
    client_name: "",
    client_email: "",
    password: "",
    confirmPassword: "",
    phone_number: "", // Changed from "Phone" to "phone_number"
    address: "",
    website: "",
    account_url: "",
    is_active: true,
    plan_id: "",
    photo: null as File | null,
  });

  const [editFormValues, setEditFormValues] = useState({
    client_name: "",
    client_email: "",
    password: "",
    address: "",
    website: "",
    account_url: "",
    is_active: true,
    plan_id: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormValues((prev) => ({ ...prev, photo: file }));
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues((prev) => ({
      ...prev,
      is_active: e.target.value === "Active",
    }));
  };
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  // Fetch plan when modal opens or client ID changes
  useEffect(() => {
    if (!selectedClientId) return;

    const fetchPlan = async () => {
      try {
        const data = await fetchClientPlan(selectedClientId);
        setClientPlan(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchPlan();
  }, [selectedClientId]);

  const handleUpgradePlan = async () => {
    if (
      !selectedClientId ||
      !newPlanId || // ✅ validate plan_id
      !newPlanName ||
      !newPlanType ||
      !paymentDate ||
      !expireDate ||
      !newPlanPrice
    ) {
      toast.error("Please fill all required plan fields");
      return;
    }

    try {
      await updateClientPlan(selectedClientId, {
        plan_id: newPlanId, // ✅ send it here
        plan_name: newPlanName,
        plan_type: newPlanType,
        plan_price: parseFloat(newPlanPrice),
        payment_date: paymentDate.toISOString().split("T")[0],
        expire_date: expireDate.toISOString().split("T")[0],
      });

      const updated = await fetchClientPlan(selectedClientId);
      setClientPlan(updated);

      toast.success("Client plan updated successfully!");
    } catch (error) {
      console.error("Error updating plan:", error);
    }
  };

  const resetAddClientForm = () => {
  setFormValues({
    client_name: "",
    client_email: "",
    password: "",
    confirmPassword: "",
    phone_number: "",
    address: "",
    website: "",
    account_url: "",
    is_active: true,
    plan_id: "",
    photo: null,
  });
};

  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !formValues.client_name ||
      !formValues.client_email ||
      !formValues.password ||
      !formValues.plan_id
    ) {
      toast.error("Please fill all mandatory fields!");
      return;
    }

    if (!emailRegex.test(formValues.client_email)) {
      toast.error("Please enter a valid email address!");
      return;
    }

    try {
      const clientPayload = {
        client_name: formValues.client_name,
        client_email: formValues.client_email,
        password: formValues.password,
        address: formValues.address,
        website: formValues.website,
        account_url: formValues.account_url,
        is_active: formValues.is_active,
        plan_id: formValues.plan_id,
      };

      await createClient(clientPayload);

      const res = await fetchClients();
      const formatted = res.map((client: any, index: number) => ({
        key: index,
        ...client,
        CompanyName: client.client_name,
        Email: client.client_email,
        AccountURL: client.account_url || "-",
        Plan: client.plan?.plan_name || "N/A",
        CreatedDate: client.created_at || "",
        Status: client.is_active ? "Active" : "Inactive",
        Image: "company-icon-01.svg",
      }));

      setData(formatted);
      setClients(formatted);
      setFilteredClients(formatted);
      resetAddClientForm(); 
      toast.success("Client created successfully!");
    } catch (error) {
      console.error(error);
      console.error("Failed to create client.");
    }
  };

  useEffect(() => {
    const loadCustomClients = async () => {
      try {
        const clients = await fetchCustomClientInfo();
      } catch (err) {
        console.error("Error loading custom client info:", err);
      }
    };

    loadCustomClients();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clients = await fetchClients();
        const formattedClients = clients.map((client: any, index: number) => ({
          key: index,
          client_id: client.client_id, // Adding client_id to ensure it's available for edit/delete operations
          CompanyName: client.client_name,
          Email: client.client_email,
          AccountURL: client.account_url,
          Plan: client.plan?.plan_name || "N/A",
          CreatedDate: client.created_at || "",
          Status: client.is_active ? "Active" : "Inactive",
          Image: "company-icon-01.svg",
        }));
        setData(formattedClients);

        const plans = await fetchPlans();
        const formattedPlans = plans.map((plan) => ({
          label: plan.plan_name,
          value: plan.plan_id,
        }));
        setPlans(formattedPlans);
      } catch (error) {
        console.error("Failed to fetch clients or plans:", error);
      }
    };

    fetchData();
  }, []);
  const handleUpdateClient = async () => {
    if (!selectedClientId) {
      toast.error("No client selected for update.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !editFormValues.client_email ||
      !emailRegex.test(editFormValues.client_email)
    ) {
      toast.error("Please enter a valid email address!");
      return;
    }

    try {
      await updateClient(selectedClientId, editFormValues);

      const res = await fetchClients();
      const formatted = res.map((client: any, index: number) => ({
        key: index,
        ...client,
        CompanyName: client.client_name,
        Email: client.client_email,
        AccountURL: client.account_url || "-",
        Plan: client.plan?.plan_name || "N/A",
        CreatedDate: client.created_at || "",
        Status: client.is_active ? "Active" : "Inactive",
        Image: "company-icon-01.svg",
      }));

      setData(formatted);
      setClients(formatted);
      setFilteredClients(formatted);

      toast.success("Client updated successfully!");
    } catch (error) {
      console.error("Error updating client:", error);
    }
  };

  const handleDeleteClient = async (client_id: string) => {
    try {
      await deleteClient(client_id); // ✅ Call delete API
      toast.success("Client deleted!");

      const clients = await fetchClients();
      const formattedClients = clients.map((client: any, index: number) => ({
        key: index,
        ...client,
        client_id: client.client_id, // Ensure client_id is included
        CompanyName: client.client_name,
        Email: client.client_email,
        AccountURL: client.account_url || "-",
        Plan: client.plan?.plan_name || "N/A", // Use optional chaining for plan
        CreatedDate: client.created_at || "",
        Status: client.is_active ? "Active" : "Inactive",
        Image: "company-icon-01.svg",
      }));
      setData(formattedClients);
      setClientIdToDelete(null); // Reset the clientIdToDelete after deletion
      setClients(formattedClients);
      setFilteredClients(formattedClients);
    } catch (error) {
      console.error(error);
    }
  };

  // Function to handle delete confirmation from modal
  const confirmDeleteClient = () => {
    if (clientIdToDelete) {
      handleDeleteClient(clientIdToDelete);
    }
  };

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    data.forEach((_, index) => {
      starsState[index] = false;
    });

    setStars(starsState);
  };

  // Call initializeStarsState once when the component mounts
  React.useEffect(() => {
    initializeStarsState();
  }, []);

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };

  useEffect(() => {
    const loadClients = async () => {
      try {
        const res = await fetchClients();
        const formatted = res.map((client: any, index: number) => ({
          key: index,
          ...client, // retain full original fields
          CompanyName: client.client_name,
          Email: client.client_email,
          AccountURL: client.account_url || "-",
          Plan: client.plan?.plan_name || "N/A",
          CreatedDate: client.created_at || "",
          Status: client.is_active ? "Active" : "Inactive",
          Image: "company-icon-01.svg",
        }));

        setClients(formatted);
        setFilteredClients(formatted);
      } catch (error) {
        console.error("Failed to fetch clients", error);
      }
    };

    loadClients();
  }, []);

  useEffect(() => {
    let updated = [...clients];

    // 🔍 Filter
    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      updated = updated.filter(
        (client) =>
          client.CompanyName?.toLowerCase().includes(query) ||
          client.Email?.toLowerCase().includes(query) ||
          client.Plan?.toLowerCase().includes(query)
      );
    }

    // Date Range Filter
    if (dateRange.startDate !== null && dateRange.endDate !== null) {
      updated = updated.filter((client) => {
        const created = new Date(client.CreatedDate).getTime();
        return (
          created >= dateRange.startDate!.getTime() &&
          created <= dateRange.endDate!.getTime()
        );
      });
    }

    // ↕️ Sort
    switch (sortOption) {
      case "ascending":
        updated.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName));
        break;
      case "descending":
        updated.sort((a, b) => b.CompanyName.localeCompare(a.CompanyName));
        break;
      case "recently_added":
        updated.sort(
          (a, b) =>
            new Date(b.CreatedDate).getTime() -
            new Date(a.CreatedDate).getTime()
        );
        break;
      // You can implement `recently_viewed` logic here if needed
      default:
        break;
    }

    setFilteredClients(updated);
  }, [searchQuery, sortOption, clients, dateRange]);

  const handleResetFilters = () => {
    setSearchQuery("");
  };

  const allColumns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
   {
  title: "Name",
  dataIndex: "CompanyName",
  render: (text: any, record: any) => (
    <div className="d-flex align-items-center">
      <div className="avatar avatar-sm bg-light text-primary rounded-circle me-2 fw-semibold">
        {text?.[0]?.toUpperCase() || "C"}
      </div>
      <div>
        {highlightMatch(
          text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase(),
          searchQuery
        )}
      </div>
    </div>
  ),
},
    {
      title: "Email",
      dataIndex: "Email",
      render: (text: any) => highlightMatch(text, searchQuery),
    },
    {
  title: "Website",
  dataIndex: "website",
  render: (text: any) => (
    <a href={text || "#"} target="_blank" rel="noopener noreferrer">
      {highlightMatch(text || "-", searchQuery)}
    </a>
  ),
},

    {
      title: "Plan",
      dataIndex: "Plan",
      render: (text: any, record: any) => (
        <div className="d-flex align-items-center justify-content-between">
          <span>{highlightMatch(record.Plan, searchQuery)}</span>
          <Link
            to="#"
            className="badge bg-green badge-lg text-white ms-3"
            data-bs-toggle="offcanvas"
            data-bs-target="#upgrade_plan"
            onClick={() => setSelectedClientId(record.client_id)}
          >
            Upgrade
          </Link>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
       render: (_: any, record: any) => {
                const date = new Date(record.CreatedDate);
                return !isNaN(date.getTime()) ? (
                  <div>
                    <div>{date.toLocaleDateString()}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                      {date.toLocaleTimeString()}
                    </div>
                  </div>
                ) : (
                  "-"
                );
              },
            },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: any) => (
        <span
          className={`badge badge-pill badge-status ${
            text === "Active" ? "bg-success" : "bg-danger"
          }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text: any, record: any) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
  className="dropdown-item"
  to="#"
  onClick={() => {
    setSelectedClientId(record.client_id);
    setEditFormValues({
      client_name: record.client_name || "",
      client_email: record.client_email || "",
      address: record.address || "",
      password: record.password || "",
      account_url: record.account_url || "",
      website: record.website || "",
      is_active: record.is_active === true,
      plan_id: record.plan_id || "",
    });
    setShowEdit(true); // ✅ Open the panel
  }}
>
  <i className="ti ti-edit text-blue" /> Edit
</Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_company"
              onClick={() => setClientIdToDelete(record.client_id)}
            >
              <i className="ti ti-trash text-danger" />
              Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // Only show columns user selected
  const columns = allColumns.filter(
    (col) => !col.title || visibleColumns.includes(col.title)
  );

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  const planName = [
    { value: "Advanced", label: "Advanced" },
    { value: "Basic", label: "Basic" },
    { value: "Enterprise", label: "Enterprise" },
  ];
  const planType = [
    { value: "Monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                 <div className="col-4">
  <h4 className="page-title"><i className="bi bi-buildings text-primary me-2"/>
    Clients <span className="count-title">{data?.length || 0}</span>
  </h4>
</div>

                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card ">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          placeholder="Search by name, email or URL"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="form-control w-50"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        {/* <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div> */}
                       <button
  className="btn btn-primary"
  onClick={() => setShowAddClient(true)}
><i className="ti ti-square-rounded-plus me-2" />
  Add Client
</button>

                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            {[
                              { label: "Ascending", value: "ascending" },
                              { label: "Descending", value: "descending" },
                              {
                                label: "Recently Viewed",
                                value: "recently_viewed",
                              },
                              {
                                label: "Recently Added",
                                value: "recently_added",
                              },
                            ].map(({ label, value }) => {
                              const isActive = sortOption === value;
                              return (
                                <li key={value}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${
                                      isActive ? "fw-bold text-primary" : ""
                                    }`}
                                    onClick={() => setSortOption(value)}
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    {isActive && <i className="ti ti-check" />}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>

                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker
                          initialSettings={initialSettings}
                          onCallback={(start, end) => {
                            setDateRange({
                              startDate: start.toDate(),
                              endDate: end.toDate(),
                            });
                          }}
                        >
                          <input
                            className="form-control bookingrange"
                            type="text"
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Want to manage datatables?
                          </h4>
                          <p className="mb-3">
                            Please drag and drop your column to reorder your
                            table and enable see option as you want.
                          </p>
                          <div className="border-top pt-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Name
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-name"
                                  className="check"
                                  checked={visibleColumns.includes("Name")}
                                  onChange={() => handleToggleColumn("Name")}
                                />
                                <label
                                  htmlFor="col-name"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Email
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-email"
                                  className="check"
                                  checked={visibleColumns.includes("Email")}
                                  onChange={() => handleToggleColumn("Email")}
                                />
                                <label
                                  htmlFor="col-email"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
  <p className="mb-0 d-flex align-items-center">
    <i className="ti ti-grip-vertical me-2" />
    Website
  </p>
  <div className="status-toggle">
    <input
      type="checkbox"
      id="col-website"
      className="check"
      checked={visibleColumns.includes("Website")}
      onChange={() => handleToggleColumn("Website")}
    />
    <label htmlFor="col-website" className="checktoggle" />
  </div>
</div>

                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Status
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-status"
                                  className="check"
                                  checked={visibleColumns.includes("Status")}
                                  onChange={() => handleToggleColumn("Status")}
                                />
                                <label
                                  htmlFor="col-status"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Action
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-action"
                                  className="check"
                                  checked={visibleColumns.includes("Action")}
                                  onChange={() => handleToggleColumn("Action")}
                                />
                                <label
                                  htmlFor="col-action"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-sorts dropdown">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Name Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#filterName"
                                    aria-expanded="true"
                                    aria-controls="filterName"
                                  >
                                    Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="filterName"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by Name"
                                      onChange={(e) =>
                                        setSearchQuery(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Email Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#filterEmail"
                                    aria-expanded="false"
                                    aria-controls="filterEmail"
                                    className="collapsed"
                                  >
                                    Email
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="filterEmail"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by Email"
                                      onChange={(e) =>
                                        setSearchQuery(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Plan Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#filterPlan"
                                    aria-expanded="false"
                                    aria-controls="filterPlan"
                                    className="collapsed"
                                  >
                                    Plan
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="filterPlan"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by Plan"
                                      onChange={(e) =>
                                        setSearchQuery(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Filter/Reset Buttons */}
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6">
                                  <div className="col-6">
                                    <button
                                      type="button"
                                      className="btn btn-light w-100"
                                      onClick={handleResetFilters}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <Link to="#" className="btn btn-primary">
                                    Filter
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Filter */}
                  {/* Contact List */}
                  <div className="table-responsive custom-table">
                    <Table
                      dataSource={filteredClients}
                      columns={columns}
                      className="custom-table"
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"],
                        onChange: (page: number, size: number) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        },
                      }}
                      scroll={{ x: "max-content" }} // Enables horizontal scroll
                      components={{
                        header: {
                          cell: (props: any) => (
                            <th
                              {...props}
                              style={{
                                ...props.style,
                                position: "sticky",
                                top: 0,
                                zIndex: 2, // Better layering over scrollbars/fixed columns
                                background: "#fff",
                                boxShadow: "inset 0 -1px 0 #f50e0e", // ✅ fix this invalid color
                              }}
                            />
                          ),
                        },
                      }}
                    />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Contact List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <>
        {/* Add Company */}
      {showAddClient && (
  <>
    {/* Backdrop */}
    <div
      className="offcanvas-backdrop fade show"
      onClick={() => setShowAddClient(false)}
      style={{ zIndex: 1040 }}
    />

        {/* Custom Offcanvas Panel */}
    <div
      className="offcanvas offcanvas-end offcanvas-large show d-block"
      style={{ visibility: "visible", zIndex: 1050 }}
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Add New Client</h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          onClick={() => setShowAddClient(false)}
          aria-label="Close"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div
        className="offcanvas-body overflow-auto"
        style={{ maxHeight: "calc(100vh - 60px)" }}
      >
            <form>
              <h6 className="fw-semibold border-bottom pb-1 mt-3 mb-3">
                <i className="ti ti-building me-2 text-primary" />
                Client Information
              </h6>

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="col-form-label">
                    Company Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="client_name"
                    value={formValues.client_name}
                    onChange={handleInputChange}
                    placeholder="Company Name"
                  />
                </div>

                <div className="col-md-6">
                  <label className="col-form-label">
                    Client Email <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="client_email"
                    value={formValues.client_email}
                    onChange={handleInputChange}
                    onBlur={(e) =>
                      setFormValues({
                        ...formValues,
                        client_email: e.target.value.trim(),
                      })
                    }
                    placeholder="Email"
                  />
                </div>
                {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">Account URL</label>
                        <input
                          type="text"
                          className="form-control"
                          name="account_url"
                          value={formValues.account_url}
                          onChange={handleInputChange}
                          placeholder="Account URL"
                        />
                      </div>
                    </div> */}

                <div className="col-md-6">
                  <label className="col-form-label">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group position-relative">
                    <input
                      type={passwordVisibility.password ? "text" : "password"}
                      className="form-control"
                      name="password"
                      value={formValues.password}
                      onChange={handleInputChange}
                      placeholder="Password"
                    />
                    <span
                      className={`ti position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer ${
                        passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => togglePasswordVisibility("password")}
                    ></span>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="col-form-label">Website</label>
                  <input
                    type="text"
                    className="form-control"
                    name="website"
                    value={formValues.website}
                    onChange={handleInputChange}
                    placeholder="Website"
                  />
                </div>

                <div className="col-md-12">
                  <label className="col-form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formValues.address}
                    onChange={handleInputChange}
                    placeholder="Address"
                  />
                </div>

                {/*      <div className="col-md-6">
                       <div className="mb-3 ">
                        <label className="col-form-label">
                          Plan Name <span className="text-danger"> *</span>
                        </label>
                        <Select
                          options={planName}
                          className="select2"
                        />
                      </div>
                    </div> */}
                <div className="col-md-6">
                  <label className="col-form-label">
                    Plan Type <span className="text-danger"> *</span>
                  </label>
                  <Select
                    options={plans}
                    name="plan_id"
                    onChange={(selectedOption: any) => {
                      setFormValues((prev) => ({
                        ...prev,
                        plan_id: selectedOption.value,
                      }));
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="col-form-label">Status</label>
                  <div className="d-flex mt-2">
                    <div className="form-check me-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_active"
                        value="Active"
                        checked={formValues.is_active === true}
                        onChange={handleRadioChange}
                      />
                      <label className="form-check-label">Active</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_active"
                        value="Inactive"
                        checked={formValues.is_active === false}
                        onChange={handleRadioChange}
                      />
                      <label className="form-check-label">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Buttons */}
                 <div className="d-flex align-items-center justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setShowAddClient(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Create
            </button>
              </div>
            </form>
          </div>
        </div>
        </>
      )}
        {/* /Add Company */}

        {/* Edit Company */}
        {showEdit && (
  <>
    {/* Backdrop */}
    <div
      className="offcanvas-backdrop fade show"
      onClick={() => setShowEdit(false)}
      style={{ zIndex: 1040 }}
    />

    {/* Panel */}
    <div
      className="offcanvas offcanvas-end offcanvas-large show d-block"
      style={{ visibility: "visible", zIndex: 1050 }}
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Edit Company</h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          onClick={() => setShowEdit(false)} // ✅ closes panel
          aria-label="Close"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div
        className="offcanvas-body overflow-auto"
        style={{ maxHeight: "calc(100vh - 60px)" }}
      >
            <form>
              <div className="row g-3">
                {/* Section Heading */}
                <h6 className="mt-3 mb-3 border-bottom pb-1 fw-semibold">
                  <i className="ti ti-building me-2 text-primary" />
                  Client Information
                </h6>
                <div className="row">
                  {/* Upload Profile Image - Skipped for now since your API doesn't support file upload */}

                  {/* Company Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Company Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="client_name"
                        value={editFormValues.client_name || ""}
                        onChange={(e) =>
                          setEditFormValues((prev) => ({
                            ...prev,
                            client_name: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Client Email */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        name="client_email"
                        value={editFormValues.client_email || ""}
                        onChange={(e) =>
                          setEditFormValues((prev) => ({
                            ...prev,
                            client_email: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Account URL */}
                  {/* <div className="col-md-12">
              <div className="mb-3">
                <label className="col-form-label">Account URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="account_url"
                  value={editFormValues.account_url || ""}
                  onChange={(e) =>
                    setEditFormValues((prev) => ({
                      ...prev,
                      account_url: e.target.value,
                    }))
                  }
                />
              </div>
            </div> */}

                  {/* Password Field */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Password</label>
                      <div className="pass-group position-relative">
                        <input
                          type={
                            passwordVisibility.password ? "text" : "password"
                          }
                          className="form-control"
                          name="password"
                          value={editFormValues.password || ""}
                          onChange={(e) =>
                            setEditFormValues((prev) => ({
                              ...prev,
                              password: e.target.value,
                            }))
                          }
                        />
                        <span
                          className={`ti position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer toggle-passwords ${
                            passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() => togglePasswordVisibility("password")}
                        ></span>
                      </div>
                    </div>
                  </div>

                  {/* Website */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Website</label>
                      <input
                        type="text"
                        className="form-control"
                        name="website"
                        value={editFormValues.website || ""}
                        onChange={(e) =>
                          setEditFormValues((prev) => ({
                            ...prev,
                            website: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={editFormValues.address || ""}
                        onChange={(e) =>
                          setEditFormValues((prev) => ({
                            ...prev,
                            address: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Plan Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Plan Type <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={plans}
                        name="plan_id"
                        value={plans.find(
                          (plan) => plan.value === editFormValues.plan_id
                        )}
                        onChange={(selectedOption: any) =>
                          setEditFormValues((prev) => ({
                            ...prev,
                            plan_id: selectedOption.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Status Radio */}
                  <div className="col-md-6">
                    <div className="mb-0">
                      <div className="radio-wrap">
                        <label className="col-form-label">Status</label>
                        <div className="d-flex flex-wrap">
                          <div className="me-2">
                            <label>
                              <input
                                type="radio"
                                name="is_active"
                                value="Active"
                                checked={editFormValues.is_active === true}
                                onChange={() =>
                                  setEditFormValues((prev) => ({
                                    ...prev,
                                    is_active: true,
                                  }))
                                }
                              />{" "}
                              Active
                            </label>
                          </div>
                          <div>
                            <label>
                              <input
                                type="radio"
                                name="is_active"
                                value="Inactive"
                                checked={editFormValues.is_active === false}
                                onChange={() =>
                                  setEditFormValues((prev) => ({
                                    ...prev,
                                    is_active: false,
                                  }))
                                }
                              />{" "}
                              Inactive
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                {/* /row */}
              </div>

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-end">
                <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setShowEdit(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpdateClient}
            >
              Update
            </button>
              </div>
            </form>
          </div>
        </div>
        </>
        )}
        {/* /Edit Company */}

        {/* Upgrade Plane */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="upgrade_plan"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Upgrade Package</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="card">
                <div className="card-body pb-0">
                  <div className="mb-1">
                    <div className="">
                      <h5 className="mb-3">Current Plan Details</h5>
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Company Name</p>
                            <p className="text-gray-9">
                              {clientPlan?.client_name || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Plan Name</p>
                            <div className="card border bg-light p-3 mb-3">
                              <p className="fw-semibold mb-1">
                                You are upgrading from:
                              </p>
                              <p className="mb-0">
                                {clientPlan?.plan_name} →{" "}
                                <strong>{newPlanName || "Select Plan"}</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Plan Type</p>
                            <p className="text-gray-9">
                              {clientPlan?.plan_type || "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Price</p>
                            <p className="text-gray-9">
                              {clientPlan?.plan_price || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Register Date</p>
                            <p className="text-gray-9">
                              {" "}
                              {clientPlan?.payment_date
                                ? new Date(
                                    clientPlan.payment_date
                                  ).toLocaleDateString()
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Expiring On</p>
                            <p className="text-gray-9">
                              {" "}
                              {clientPlan?.expire_date
                                ? new Date(
                                    clientPlan.expire_date
                                  ).toLocaleDateString()
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h5 className="mb-3">Change Plan</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Plan Name <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={plans}
                            className="select2"
                            onChange={(option) => {
                              setNewPlanName(option?.label || "");
                              setNewPlanId(option?.value || "");
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="col-form-label">
                            Plan Type <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={planType}
                            className="select2"
                            getOptionLabel={(e) => e.label}
                            formatOptionLabel={(e) => (
                              <span>
                                <i
                                  className={`ti ${
                                    e.value === "Monthly"
                                      ? "ti-calendar"
                                      : "ti-calendar-stats"
                                  }`}
                                />{" "}
                                {e.label}
                              </span>
                            )}
                            onChange={(option) =>
                              setNewPlanType(option?.value || "")
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Amount<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            inputMode="decimal" // Suggests number keyboard on mobile
                            className="form-control"
                            value={newPlanPrice}
                            onChange={(e) => setNewPlanPrice(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Payment Date <span className="text-danger">*</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker deals-details"
                              selected={paymentDate}
                              onChange={(date) => setPaymentDate(date)}
                              dateFormat="yyyy-MM-dd"
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Expiring On <span className="text-danger">*</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker deals-details"
                              selected={expireDate}
                              onChange={(date) => setExpireDate(date)}
                              dateFormat="yyyy-MM-dd"
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="offcanvas"
                  onClick={handleUpgradePlan}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Upgrade Plane */}
        {/* Delete Company */}

        <div className="modal fade" id="delete_company" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Company</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>
              <div className="modal-body text-center">
                <i className="ti ti-alert-circle h1 text-danger" />
                <h4 className="mt-3">
                  Are you sure you want to delete this company?
                </h4>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDeleteClient}
                  data-bs-dismiss="modal"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Company */}
      </>
    </>
  );
};
export default Company;
